module.exports = __webpack_public_path__ + "img/28.179b63ee.gif";